export default {
  title: 'Pet Care Note を応援',
  subtitle: 'あなたのサポートが、より良いペットケアツールを生み出す原動力です',
  oneTime: '一回のみ',
  monthly: '毎月',
  oneTimeDescription: '一度きりの応援で、開発チームにエネルギーを注ぎ、より良いツールの開発を後押し',
  monthlyDescription: '継続的なサポーターとなり、Pet Care Note と一緒に成長し、すべてのアップデートを見届ける',
  chooseAmount: 'サポート金額を選択',
  month: '/月',
  kittenSupport: '子猫の守護者',
  puppySupport: '子犬の守護者',
  bunnySupport: 'うさぎの守護者',
  securePayment: 'Stripe で安全に暗号化決済',
  linkNotConfigured: '支払いリンクが未設定です。開発チームにお問い合わせください。'
};